export default "__VITE_ASSET__52a8641c__"